<template>
  <el-dialog
    title=""
    :visible.sync="dialogShow"
    width="471px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    custom-class="save-record-name-dialog"
  >
    <div class="save-record-name-wrapper">
      <div class="save-record-name-wrapper-head">
        <h5 class="dialog-title">保存搜索条件</h5>
        <i @click="close" class="dialog-close iconfont icon-icon-guanbi"></i>
      </div>
      <el-form
        class="save-record-name-wrapper-form"
        ref="form"
        :model="formAlignData"
        :rules="rules"
        label-position="left"
        label-width="112px"
      >
        <el-form-item label="搜索条件名称" prop="name">
          <el-input v-model="formAlignData.name" :maxlength="20"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="save-record-name-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="comfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  saveBuyerSearchCondition,
  renameBuyerSearchRecord,
} from "@/utils/api/seamark";

export default {
  name: "save-record-name-dialog",
  props: ["show"],
  data() {
    return {
      submitLoading: false, //提交时的状态，用于防止重复提交
      formAlignData: {
        name: "",
      },
      condition: {}, //搜索条件，通过从refs进行赋值
      recordId: null,
      rules: {
        name: [
          { required: true, message: "搜索条件名称为空", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("changeShow", val);
      },
    },
  },
  methods: {
    async saveBuyerSearchCondition() {
      // ？？？根据id和searchCondition区分是否在重命名，否则就是在新建
      const params = {
        name: this.formAlignData.name,
        searchCondition: {
          ...this.condition,
        },
      };
      const res = await saveBuyerSearchCondition(params);
      this.submitLoading = false;
      try {
        if (res.rspResult.bizCode == 200) {
          this.close();
          this.$emit("changeTab", 1); //保存完了，切到搜索记录tab上
          this.$message.success(res.rspResult.message);
        } else {
          // this.$message.error(res.rspResult.message);
        }
      } catch (err) {
        this.submitLoading = false;
        console.error("保存搜索条件出错", err);
      }
    },
    // 重命名
    async renameBuyerSearchRecord() {
      // ？？？根据id和searchCondition区分是否在重命名，否则就是在新建
      const params = {
        id: this.recordId,
        name: this.formAlignData.name,
      };
      const res = await renameBuyerSearchRecord(params);
      this.submitLoading = false;
      try {
        if (res.rspResult.bizCode == 200) {
          this.$emit("reloadRecords");
          this.close();
          this.$message.success(res.rspResult.message);
        } else {
          // this.$message.error(res.rspResult.message);
        }
      } catch (err) {
        this.submitLoading = false;
        console.error("保存搜索条件出错", err);
      }
    },
    comfirm() {
      if (this.submitLoading) return;
      const form = this.$refs.form;
      form.validate((valid) => {
        console.log("校验结果", valid);
        if (valid) {
          this.submitLoading = true;
          if (!this.recordId) {
            // 新建
            this.saveBuyerSearchCondition();
          } else {
            // 重命名
            this.renameBuyerSearchRecord();
          }
        }
      });
    },
    close() {
      // 在此之前先清空字段
      this.formAlignData.name = "";
      this.condition = {};
      this.recordId = null;
      this.dialogShow = false;
      this.$refs.form.clearValidate();
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
::v-deep .save-record-name-dialog {
  height: max-content;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto !important;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px;
    .save-record-name-wrapper {
      &-head {
        display: flex;
        height: 16px;
        justify-content: space-between;
        margin-bottom: 36px;
        .dialog-title {
          height: 16px;
          line-height: 16px;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          font-size: 16px;
          color: #16181a;
        }
        .dialog-close {
          color: #98a3b7;
          font-size: 16px;
          line-height: 16px;
          cursor: pointer;
          &:hover {
            color: #8893a7;
          }
        }
      }
      &-form {
        .el-form-item {
          &__label {
            font-family: SourceHanSansCN-Regular;
            color: #16181a;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0;
            // paragraph-spacing: 0;
          }
          .el-input__inner {
            color: #16181a;
          }
        }
      }
    }
    .save-record-name-footer {
      margin-top: 36px;
      text-align: right;
      .el-button {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 12px;
        letter-spacing: 0;
        &:nth-child(1) {
          color: #16181a;
        }
      }
    }
  }
}
</style>